"use client";
import { useState, Suspense, useEffect } from "react";
import classes from "./SellerInformation.module.css";
import ToolTip from "../../../../../components/UI/ToolTip";
import { FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa";
import { Spinner } from "react-bootstrap";
import moment from "moment";
import ReviewsModal from "../../../../../components/modals/product-related/ReviewsModal";
import { useSellerReviewsContext } from "@/context/sellerReviews";
import { BadgeCheck } from "lucide-react";
import { Tag } from "react-feather";

const SellerInformation = (props) => {
  const [showReviewsModal, setShowReviewsModal] = useState(false);
  const [typeReview, setTypeReview] = useState();

  const { author, listing } = props;

  const { sellerReviews, LOAD_REVIEW } = useSellerReviewsContext();

  function handleHashChange() {
    if (global?.window && window.location.hash === "#askSeller") {
      scrollHandler();
    }
  }

  const [page, setPage] = useState(1);

  useEffect(() => {
    let found = sellerReviews.reviews?.find(
      (review) => review.id === author._id
    );

    if (found?.page < page) {
      LOAD_REVIEW(author._id, page);
    }
  }, [page]);

  useEffect(() => {
    let found = sellerReviews.reviews?.find(
      (review) => review.id === author._id
    );

    if (!found) {
      LOAD_REVIEW(author._id, page);
    }
  }, [author]);

  useEffect(() => {
    global?.window && handleHashChange();
  }, []);

  const scrollHandler = () => {
    const element = document?.getElementById("askSellerTarget");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  function extractCityState(address) {
    const parts = address?.split(","); // Split the address by comma
    if (parts?.length >= 3) {
      const city = parts[parts.length - 3].trim(); // City is the second last part
      const state = parts[parts.length - 2].trim(); // State is the last part
      return `${city}, ${state}`;
    } else {
      return null; // Return null if the address format is incorrect
    }
  }

  const roundedReview =
    Math.ceil(
      sellerReviews.reviews?.find((review) => review.id === author._id)
        ?.averageReview * 2
    ) / 2;

  // Step 2: Determine the number of full stars, half stars, and empty stars
  const fullStars = Math.floor(roundedReview);
  const halfStars = roundedReview % 1 !== 0 ? 1 : 0;
  const emptyStars = 5 - fullStars - halfStars;

  const showReviewsHandler = (type) => {
    setTypeReview(type);
    setShowReviewsModal(!showReviewsModal);
  };

  return (
    <>
      <section className={classes.sellerInfoBg}>
        <section className={classes.sellerInfoColGap}>
          <div className={classes.sellerInfo}>
            {author && (author.business === "yes" || author.isBusiness) ? (
              <ToolTip
                header="Curated Professional Reseller:"
                text="Handpicked for their reliability and unique taste, discover the treasures this professional reseller has to offer."
              >
                <div className={classes.sellerBadge}>
                  <BadgeCheck className={classes.approvedBadge} />
                  Professional Reseller
                </div>
              </ToolTip>
            ) : (
              <ToolTip
                header="Kashew-Verified Seller:"
                text=" We've confirmed the identity and contact details of this seller for your peace of mind."
              >
                <div className={classes.sellerBadgeBlue}>
                  <BadgeCheck className={classes.approvedBadge} />
                  Verified Seller{" "}
                </div>
              </ToolTip>
            )}
            {sellerReviews?.loading ? (
              <>
                <div
                  className={classes.sellerSales}
                  onClick={() => showReviewsHandler("sales")}
                >
                  <Tag className={classes.salesBadge} />{" "}
                  <Spinner
                    animation="border"
                    variant="success"
                    size="sm"
                    style={{
                      marginRight: "5px",
                    }}
                  />{" "}
                  sales
                </div>
              </>
            ) : sellerReviews.reviews?.find(
                (review) => review.id === author._id
              )?.totalCount > 0 && !sellerReviews?.loading ? (
              <>
                <div
                  className={classes.sellerSales}
                  onClick={() => showReviewsHandler("sales")}
                >
                  <Tag className={classes.salesBadge} />
                  {
                    sellerReviews.reviews?.find(
                      (review) => review.id === author._id
                    )?.totalCount
                  }{" "}
                  sales
                </div>
              </>
            ) : (
              ""
            )}
          </div>
          {sellerReviews.reviews?.find((review) => review.id === author._id)
            ?.averageReview !== "0" &&
            sellerReviews.reviews?.find((review) => review.id === author._id)
              ?.averageReview > 1 && (
              <div
                className={classes.review}
                onClick={() => showReviewsHandler("reviews")}
              >
                {[...Array(fullStars)].map((_, i) => (
                  <FaStar key={`full_${i}`} className={classes.reviewIcon} />
                ))}
                {halfStars === 1 && (
                  <FaStarHalfAlt key="half" className={classes.reviewIcon} />
                )}
                {[...Array(emptyStars)].map((_, i) => (
                  <FaRegStar
                    key={`empty_${i}`}
                    className={classes.reviewIcon}
                  />
                ))}
                <span className={classes.mgleft}>
                  {roundedReview.toFixed(1)} (
                  {
                    sellerReviews.reviews?.find(
                      (review) => review.id === author._id
                    )?.reviewedCount
                  }{" "}
                  reviews)
                </span>
              </div>
            )}
          <section className={classes.gapRow5px}>
            {/* <img
              src={`https://ik.imagekit.io/kuj9zqlrx0or/Static/state_logos/${AbbreviateState(
                extractState(listing?.store?.locationInfo?.address)
              )}.png?tr=w-200`}
              alt="seller"
              className={classes.stateImg}
            /> */}
            <div className={classes.location}>
              {extractCityState(listing?.store?.locationInfo?.address)}
            </div>
            <div className={classes.dot}></div>
            <div className={classes.location}>
              On Kashew since {moment(author?.date).format("MMM YYYY")}
            </div>
          </section>
        </section>

        <button onClick={() => scrollHandler()} className={classes.askQuestion}>
          Ask Seller a Question
        </button>
      </section>

      <Suspense fallback={<></>}>
        <ReviewsModal
          author={author}
          showReviewsModal={showReviewsModal}
          setShowReviewsModal={setShowReviewsModal}
          typeReview={typeReview}
          page={page}
          setPage={setPage}
        />
      </Suspense>
    </>
  );
};
export default SellerInformation;
